import { reactify } from '@zeiss/zui-react';
export const ZuiIconSymbolsSquare = reactify('zui-icon-symbols-square');
